"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* Field boxes live in fractions of their page (0 to 1). These turn pointer
 * positions on screen into page fractions and keep every box inside its page. */





const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v))

/* The smallest box a resize leaves, in fractions of the page. */
 const MIN_SIZE = { w: 0.015, h: 0.01 }; exports.MIN_SIZE = MIN_SIZE

/* Default sizes, as fractions of the page's width for both sides, so a
 * checkbox stays square on any page shape. */
const DEFAULT_SIZES = {
  text: { w: 0.3, h: 0.03 },
  date: { w: 0.18, h: 0.03 },
  time: { w: 0.12, h: 0.03 },
  checkbox: { w: 0.025, h: 0.025 },
  choice: { w: 0.3, h: 0.08 },
  initials: { w: 0.08, h: 0.03 },
  signature: { w: 0.35, h: 0.04 },
  rows: { w: 0.8, h: 0.25 },
}

/* A new field's size in page fractions, for a page of width x height. */
 const defaultSize = (type, width, height) => {
  const s = DEFAULT_SIZES[type]
  return { w: s.w, h: Math.min(1, s.h * width / height) }
}; exports.defaultSize = defaultSize

/* A new box of this size centred on the pointer, kept inside the page. */
 const dropBox = (px, py, page, size) => ({
  x: clamp((px - page.left) / page.width - size.w / 2, 0, 1 - size.w),
  y: clamp((py - page.top) / page.height - size.h / 2, 0, 1 - size.h),
  w: size.w,
  h: size.h,
}); exports.dropBox = dropBox

/* The box moved by (dx, dy) pixels on a page drawn at this size, kept inside it. */
 const moveBox = (box, dx, dy, page) => ({
  ...box,
  x: clamp(box.x + dx / page.width, 0, 1 - box.w),
  y: clamp(box.y + dy / page.height, 0, 1 - box.h),
}); exports.moveBox = moveBox

/* The box grown from its bottom-right corner by (dx, dy) pixels, kept inside
 * the page and no smaller than MIN_SIZE. */
 const resizeBox = (box, dx, dy, page) => ({
  ...box,
  w: clamp(box.w + dx / page.width, exports.MIN_SIZE.w, 1 - box.x),
  h: clamp(box.h + dy / page.height, exports.MIN_SIZE.h, 1 - box.y),
}); exports.resizeBox = resizeBox

/* The index of the page under the pointer, or -1. */
 const pageAt = (px, py, pages) => pages.findIndex(r =>
  !!r && px >= r.left && px <= r.left + r.width && py >= r.top && py <= r.top + r.height); exports.pageAt = pageAt
